import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import _slicedToArray from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSellerList, getShopDataAnalyse, shopDataDownload } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { getShiftInfoList } from '@/api/bairun/bairunData.js'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import * as DateUtil from '@/utils/date';
import { Common } from '@/utils/common';
import * as echarts from 'echarts';
import { saveAs } from 'file-saver';

var _this;

export default {
  name: 'BairunBianlidianSaleAnalyse',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatTime: function formatTime(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'MM-dd hh:mm');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerShortName: function getSellerShortName(sellerId) {
      if (sellerId == 0) {
        return '总';
      }

      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId === sellerId) {
          return _this.sellerOptions[i].shortSellerName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: '',
      type: '',
      sellerOptions: [],
      showSelSeller: false,
      searchInfo: {
        period: 0,
        dateTime: new Date(),
        startTime: '',
        endTime: '',
        timeTag: 'date',
        sellerId: 0
      },
      endTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          // return ture表示日期不可选
          return !DateUtil.isBeforeMonth(_this.searchInfo.startTime, time.Format('yyyy-MM-dd hh:mm:ss'), 1, 'date');
        }
      },
      echartsSaleTotal: null,
      echartsSaleTotalMoney: 0,
      echartsSaleTotalNum: 0,
      echartsQuShi: null,
      echartsZhanBi: null,
      checkTab: 'qushi',
      zhanbiTable: {
        table: [],
        show: 'xiaoshoue'
      },
      paihangTable: {
        table: []
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getSellerList({
                  page: 1,
                  pageSize: 999999,
                  sellerSource: 1,
                  donNotShowLoading: true
                });

              case 2:
                sellerOptions = _context3.sent;
                _this3.sellerOptions = sellerOptions.data.list;

                if (_this3.sellerOptions.length === 1) {
                  _this3.sellerId = _this3.sellerOptions[0].sellerId;
                }

                Common.echarts = [];

                _this3.onSubmit();

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onInputChange: function onInputChange() {
      this.$forceUpdate();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      if (this.searchInfo.timeTag === 'custom') {
        this.searchInfo.period = 0;
      } else {
        var _DateUtil$getStartAnd = DateUtil.getStartAndEnd(this.searchInfo.timeTag, this.searchInfo.dateTime);

        var _DateUtil$getStartAnd2 = _slicedToArray(_DateUtil$getStartAnd, 3);

        this.searchInfo.startTime = _DateUtil$getStartAnd2[0];
        this.searchInfo.endTime = _DateUtil$getStartAnd2[1];
        this.searchInfo.period = _DateUtil$getStartAnd2[2];
      }

      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        return;
      }

      this.showSelSeller = false;
      this.initEchartsSaleTotal();
      this.onCheckTab();
      this.$forceUpdate();
    },
    onCheckTime: function onCheckTime() {
      if (this.searchInfo.timeTag === 'custom') {
        this.searchInfo.period = 0;
        this.searchInfo.startTime = '';
        this.searchInfo.endTime = '';
        return;
      }

      this.onSubmit();
    },
    onCheckTab: function onCheckTab() {
      if (this.checkTab === 'qushi') {
        this.initEchartsQuShi();
      }

      if (this.checkTab === 'zhanbi') {
        this.initEchartsZhanBi();
      }

      if (this.checkTab === 'paihang') {
        this.initPaihang();
      }
    },
    // 销售汇总
    initEchartsSaleTotal: function initEchartsSaleTotal() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var unit, option, xAxis, xiaoshoue, xiaoliang, echartsSaleTotalMoney, echartsSaleTotalNum, param, res, max;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                unit = 0;
                xAxis = [];
                xiaoshoue = [];
                xiaoliang = [];
                echartsSaleTotalMoney = 0;
                echartsSaleTotalNum = 0;
                param = {
                  'dataType': 1,
                  'sellerId': _this4.searchInfo.sellerId,
                  'period': _this4.searchInfo.period,
                  'timeTag': _this4.searchInfo.timeTag,
                  'startTime': _this4.searchInfo.startTime,
                  'endTime': _this4.searchInfo.endTime
                };
                _context4.next = 9;
                return getShopDataAnalyse(param);

              case 9:
                res = _context4.sent;

                if (res.code == 0 && res.data.list) {
                  res.data.list.forEach(function (item) {
                    xAxis.push(item.shortSellerName);
                    xiaoshoue.push(item.totalTradePay);
                    xiaoliang.push(item.totalGoodsNum);
                    echartsSaleTotalMoney += parseFloat(item.totalTradePay);
                    echartsSaleTotalNum += parseFloat(item.totalGoodsNum);
                  });
                }

                max = Math.max.apply(Math, xiaoshoue);

                if (max >= 10000) {
                  unit = 10000;
                } else if (max >= 1000) {
                  unit = 1000;
                } else {
                  unit = 0;
                }

                _this4.echartsSaleTotalMoney = echartsSaleTotalMoney.toFixed(2);
                _this4.echartsSaleTotalNum = echartsSaleTotalNum;

                if (!_this4.echartsSaleTotal) {
                  _this4.echartsSaleTotal = echarts.init(document.getElementById('echartsSaleTotal'));
                  Common.echarts.push(_this4.echartsSaleTotal);
                }

                option = {
                  title: {
                    subtext: '单位（元）',
                    textStyle: {
                      fontSize: 16
                    }
                  },
                  tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                      type: 'shadow'
                    },
                    formatter: function formatter(params) {
                      if (params[0].seriesName === '销售额') {
                        return params[0].name + '<br/>' + params[0].seriesName + '：' + params[0].data + '元';
                      }

                      if (params[0].seriesName === '销量') {
                        return params[0].name + '<br/>' + params[0].seriesName + '：' + params[0].data + '件';
                      }

                      return '';
                    }
                  },
                  xAxis: {
                    type: 'category',
                    inverse: true,
                    data: xAxis
                  },
                  yAxis: {
                    type: 'value',
                    axisLabel: {
                      formatter: function formatter(value) {
                        if (unit > 0) {
                          return value / unit;
                        }

                        return value;
                      }
                    }
                  },
                  grid: {
                    left: 0,
                    right: 0,
                    bottom: 0,
                    containLabel: true
                  },
                  legend: {
                    icon: 'stack',
                    data: ['销售额', '销量'],
                    selectedMode: 'single'
                  },
                  series: [{
                    name: '销售额',
                    type: 'bar',
                    data: xiaoshoue,
                    realtimeSort: true,
                    barMaxWidth: '30rem',
                    label: {
                      show: true,
                      position: 'top',
                      formatter: function formatter(params) {
                        if (unit >= 10000) {
                          return (params.value / unit).toFixed(2) + 'W';
                        }

                        if (unit >= 1000) {
                          return (params.value / unit).toFixed(2) + 'K';
                        }

                        return params.value;
                      }
                    }
                  }, {
                    name: '销量',
                    type: 'bar',
                    data: xiaoliang,
                    realtimeSort: true,
                    barMaxWidth: '30rem',
                    label: {
                      show: true,
                      position: 'top',
                      formatter: function formatter(params) {
                        if (unit >= 10000) {
                          return (params.value / unit).toFixed(2) + 'W';
                        }

                        return params.value;
                      }
                    }
                  }]
                };

                _this4.echartsSaleTotal.on('legendselectchanged', function (e) {
                  if (e.name === '销售额') {
                    var max = Math.max.apply(Math, xiaoshoue);

                    if (max >= 10000) {
                      unit = 10000;
                    } else if (max >= 1000) {
                      unit = 1000;
                    } else {
                      unit = 0;
                    }

                    _this4.echartsSaleTotal.setOption({
                      title: {
                        subtext: '单位（元）'
                      }
                    });
                  }

                  if (e.name === '销量') {
                    var max = Math.max.apply(Math, xiaoliang);

                    if (max >= 10000) {
                      unit = 10000;
                    } else if (max >= 1000) {
                      unit = 1000;
                    } else {
                      unit = 0;
                    }

                    _this4.echartsSaleTotal.setOption({
                      title: {
                        subtext: '单位（件）'
                      }
                    });
                  }
                });

                option && _this4.echartsSaleTotal.setOption(option);

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 站点分析-趋势
    initEchartsQuShi: function initEchartsQuShi() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var subtext, startTime, endTime, res, unit, option, xAxis, xiaoshoue, xiaoliang;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                subtext = '';
                startTime = '';
                endTime = '';

                if (_this5.searchInfo.timeTag === 'date' || _this5.searchInfo.timeTag === 'year') {
                  subtext = '30天趋势';
                  startTime = DateUtil.beforeDiffMonth(_this5.searchInfo.dateTime, 1);
                  endTime = DateUtil.beforeDiffDate(_this5.searchInfo.dateTime, 1, 'yyyy-MM-dd 23:59:59');
                }

                if (_this5.searchInfo.timeTag === 'week') {
                  subtext = '当周趋势';
                  startTime = _this5.searchInfo.startTime;
                  endTime = _this5.searchInfo.endTime;
                }

                if (_this5.searchInfo.timeTag === 'month') {
                  subtext = '当月趋势';
                  startTime = _this5.searchInfo.startTime;
                  endTime = _this5.searchInfo.endTime;
                }

                if (_this5.searchInfo.timeTag === 'quarter') {
                  subtext = '当季趋势';
                  startTime = _this5.searchInfo.startTime;
                  endTime = _this5.searchInfo.endTime;
                }

                if (_this5.searchInfo.timeTag === 'custom') {
                  subtext = new Date(_this5.searchInfo.startTime).Format('MM-dd') + '~' + new Date(_this5.searchInfo.endTime).Format('MM-dd') + '趋势';
                  startTime = _this5.searchInfo.startTime;
                  endTime = _this5.searchInfo.endTime;
                }

                _context5.next = 10;
                return getShopDataAnalyse({
                  'dataType': 2,
                  'sellerId': _this5.sellerId,
                  'period': _this5.searchInfo.period,
                  'timeTag': _this5.searchInfo.timeTag,
                  'startTime': startTime,
                  'endTime': endTime
                });

              case 10:
                res = _context5.sent;
                unit = 0;
                xAxis = [];
                xiaoshoue = [];
                xiaoliang = [];
                res.data.list && res.data.list.forEach(function (item) {
                  xAxis.push(item.timeDate);
                  xiaoshoue.push(item.totalTradePay);
                  xiaoliang.push(item.totalGoodsNum);
                });

                if (!_this5.echartsQuShi) {
                  _this5.echartsQuShi = echarts.init(document.getElementById('echartsQuShi'));
                  Common.echarts.push(_this5.echartsQuShi);
                } else {
                  _this5.echartsQuShi.resize();
                }

                option = {
                  title: {
                    subtext: subtext,
                    textStyle: {
                      fontSize: 16
                    }
                  },
                  tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                      type: 'shadow'
                    },
                    formatter: function formatter(params) {
                      var s = new Date(params[0].axisValue).Format('MM月dd日') + '   ' + DateUtil.getWeekDay(params[0].axisValue);
                      params.forEach(function (item) {
                        s += '</br>' + item.seriesName + '：' + item.value + (item.seriesName === '销售额' ? '元' : '件');
                      });
                      return s;
                    }
                  },
                  xAxis: {
                    type: 'category',
                    data: xAxis,
                    axisLabel: {
                      rotate: 60,
                      formatter: function formatter(value) {
                        return new Date(value).Format('MM/dd') + DateUtil.getWeekDay(value).replaceAll('星期', '');
                      }
                    }
                  },
                  yAxis: {
                    type: 'value',
                    axisLabel: {
                      formatter: function formatter(value) {
                        if (value >= 10000) {
                          unit = 10000;
                          return value / unit;
                        } else if (value >= 1000) {
                          unit = 1000;
                          return value / unit;
                        }

                        return value;
                      }
                    }
                  },
                  grid: {
                    left: 0,
                    right: 0,
                    bottom: 0,
                    containLabel: true
                  },
                  legend: {
                    icon: 'stack',
                    data: ['销售额', '销量'],
                    selectedMode: 'multiple'
                  },
                  series: [{
                    name: '销售额',
                    type: 'line',
                    data: xiaoshoue,
                    label: {
                      show: true,
                      position: 'top',
                      formatter: function formatter(params) {
                        if (unit >= 10000) {
                          return (params.value / unit).toFixed(2) + 'W';
                        }

                        if (unit >= 1000) {
                          return (params.value / unit).toFixed(2) + 'K';
                        }

                        return params.value;
                      }
                    }
                  }, {
                    name: '销量',
                    type: 'line',
                    data: xiaoliang,
                    label: {
                      show: true,
                      position: 'top',
                      formatter: function formatter(params) {
                        return params.value;
                      }
                    }
                  }]
                };
                option && _this5.echartsQuShi.setOption(option);

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 站点分析-占比
    initEchartsZhanBi: function initEchartsZhanBi() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var option, data1, data2, param, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data1 = [];
                data2 = [];
                param = {
                  'dataType': 3,
                  'sellerId': _this6.searchInfo.sellerId,
                  'period': _this6.searchInfo.period,
                  'timeTag': _this6.searchInfo.timeTag,
                  'startTime': _this6.searchInfo.startTime,
                  'endTime': _this6.searchInfo.endTime
                };
                _context6.next = 5;
                return getShopDataAnalyse(param);

              case 5:
                res = _context6.sent;

                if (res.code == 0 && res.data.list) {
                  _this6.zhanbiTable.table = res.data.list;
                  res.data.list.forEach(function (item) {
                    data1.push({
                      name: item.categoryName,
                      value: (parseFloat(item.totalTradePayPercent) * 100).toFixed(2),
                      xiaoshoue: Number(item.totalTradePay).toFixed(2),
                      xiaoliang: Number(item.totalGoodsNum)
                    });
                    data2.push({
                      name: item.categoryName,
                      value: (parseFloat(item.totalGoodsNumPercent) * 100).toFixed(2),
                      xiaoshoue: Number(item.totalTradePay).toFixed(2),
                      xiaoliang: Number(item.totalGoodsNum)
                    });
                  });
                }

                if (!_this6.echartsZhanBi) {
                  _this6.echartsZhanBi = echarts.init(document.getElementById('echartsZhanBi'));
                  Common.echarts.push(_this6.echartsZhanBi);
                } else {
                  _this6.echartsZhanBi.resize();
                }

                option = {
                  title: {
                    subtext: '',
                    textStyle: {
                      fontSize: 16
                    }
                  },
                  tooltip: {
                    trigger: 'item',
                    formatter: function formatter(params) {
                      if (params.seriesName === '销售额') {
                        return params.name + '<br/>' + params.seriesName + '：' + params.data.xiaoshoue + '元<br/>占比：' + params.data.value + '%';
                      }

                      if (params.seriesName === '销量') {
                        return params.name + '<br/>' + params.seriesName + '：' + params.data.xiaoliang + '件<br/>占比：' + params.data.value + '%';
                      }

                      return '';
                    }
                  },
                  legend: {
                    icon: 'stack',
                    data: ['销售额', '销量'],
                    selectedMode: 'single'
                  },
                  graphic: {
                    type: 'text',
                    left: 'center',
                    top: '50%',
                    style: {
                      text: '销售额占比',
                      textAlign: 'center',
                      fill: '#333',
                      fontSize: 13,
                      fontWeight: 700
                    }
                  },
                  series: [{
                    name: '销售额',
                    type: 'pie',
                    radius: ['23%', '52%'],
                    center: ['50%', '50%'],
                    labelLine: {
                      length: 8
                    },
                    data: data1,
                    label: {
                      formatter: function formatter(params) {
                        return params.value + '%\n' + params.data.name;
                      }
                    }
                  }, {
                    name: '销量',
                    type: 'pie',
                    radius: ['23%', '52%'],
                    center: ['50%', '50%'],
                    labelLine: {
                      length: 8
                    },
                    data: data2,
                    label: {
                      formatter: function formatter(params) {
                        return params.value + '%\n' + params.data.name;
                      }
                    }
                  }]
                };

                _this6.echartsZhanBi.on('legendselectchanged', function (e) {
                  if (e.name === '销售额') {
                    _this6.zhanbiTable.show = 'xiaoshoue';

                    _this6.echartsZhanBi.setOption({
                      graphic: {
                        style: {
                          text: '销售额占比'
                        }
                      }
                    });
                  }

                  if (e.name === '销量') {
                    _this6.zhanbiTable.show = 'xiaoliang';

                    _this6.echartsZhanBi.setOption({
                      graphic: {
                        style: {
                          text: '销量占比'
                        }
                      }
                    });
                  }
                });

                option && _this6.echartsZhanBi.setOption(option);

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 站点分析-排行
    initPaihang: function initPaihang() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                param = {
                  'dataType': 4,
                  'sellerId': _this7.searchInfo.sellerId,
                  'period': _this7.searchInfo.period,
                  'timeTag': _this7.searchInfo.timeTag,
                  'startTime': _this7.searchInfo.startTime,
                  'endTime': _this7.searchInfo.endTime
                };
                _context7.next = 3;
                return getShopDataAnalyse(param);

              case 3:
                res = _context7.sent;

                if (res.code == 0) {
                  _this7.paihangTable.table = res.data.list || [];
                }

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 站点分析-排行下载
    onDownloadPaihang: function onDownloadPaihang() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                param = {
                  'dataType': 4,
                  'sellerId': _this8.searchInfo.sellerId,
                  'period': _this8.searchInfo.period,
                  'timeTag': _this8.searchInfo.timeTag,
                  'startTime': _this8.searchInfo.startTime,
                  'endTime': _this8.searchInfo.endTime
                };
                _context8.next = 3;
                return shopDataDownload(param);

              case 3:
                res = _context8.sent;

                if (res.code == 0) {
                  saveAs(res.data.fileUrl);
                }

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    }
  }
};